export default "__VITE_ASSET__BaNW9SVm__"